export default "__VITE_ASSET__BvTjXgyH__"